<div class="FilterCards">
    <span class="FilterCards__Label">{{ label() }}</span>
    <div class="FilterCards__Container">
        <!-- All Card -->
        @if (showAllCard()) {
            <div 
                class="FilterCards__Card" 
                [class.FilterCards__Card--active]="isAllSelected()"
                (click)="onAllClick()">
                <span class="FilterCards__Card__Label">{{ allCardLabel() }}</span>
                <span class="FilterCards__Card__Count">{{ totalCount() }}</span>
            </div>
        }

        <!-- Dynamic Cards -->
        @for (card of cards(); track card.id) {
            <div 
                class="FilterCards__Card" 
                [class.FilterCards__Card--active]="isSelected(card.id)"
                [style.--card-color]="card.color || '#17a2b8'"
                (click)="onCardClick(card.id)">
                <span class="FilterCards__Card__Label">{{ card.label }}</span>
                <span class="FilterCards__Card__Count">{{ card.count }}</span>
            </div>
        }
    </div>
</div>
